import type * as Models from "@/redux/models"

import type { AcceptsChildren } from "@/theme"
import React from "react"

type ProviderProps = Models.FarmField

type ContextValue = Models.FarmField
const Context = React.createContext<ContextValue | undefined>(undefined)

export function FieldProfileContextProvider({
  children,
  ...value
}: AcceptsChildren & ProviderProps): React.JSX.Element | null {
  return <Context.Provider value={value}>{children}</Context.Provider>
}

export function useFieldProfileContext(): ContextValue {
  const ctx = React.useContext(Context)

  if (typeof ctx === "undefined") {
    throw new TypeError(`FieldProfileContext must be used inside of provider`)
  }

  return ctx
}
